<template>
  <div class="topfive">
    <div class="head">
      <div class="xv">序</div>
      <div class="stock-name">股票名称</div>
      <div class="buy">融资净买额</div>
      <div class="spj">收盘价</div>
      <div class="percent">涨幅%</div>
    </div>
    <template v-if="!loaded">
      <div style="text-align:center;color:#333333">
        正在加载...
      </div>
    </template>
    <template v-else-if="loaded && z.length && d.length">
      <div class="list">
        <div class="item" v-for="(v, k) in z" :key=k @click="$router.push({path:`/${v.Market === 'SZ' ? 'sz' : 'sh'}/${v.SecuCode}.html`})">
          <div class="xv"><div class="index">{{ k+1 }}</div></div>
          <div class="stock-name">{{ v.SecuAbbr }}</div>
          <div class="buy" :class="{'green-text': v.FinaInTotal < 0}">{{ formatUnit(v.FinaInTotal) }}</div>
          <div class="spj" :class="{'green-text': v.ClosePricediv < 0}">{{ v.ClosePrice.toFixed(2) }}</div>
          <div class="percent" :class="{'green-text': v.ClosePricediv < 0}">{{ v.ClosePricedivstr }}</div>
        </div>
      </div>
      <div class="sep"></div>
      <div class="list">
        <div class="item" v-for="(v, k) in d" :key=k @click="$router.push({path:`/${v.Market === 'SZ' ? 'sz' : 'sh'}/${v.SecuCode}.html`})">
          <div class="xv"><div class="index green-bg">{{ k+1 }}</div></div>
          <div class="stock-name">{{ v.SecuAbbr }}</div>
          <div class="buy" :class="{'green-text': v.FinaInTotal < 0}">{{ formatUnit(v.FinaInTotal) }}</div>
          <div class="spj" :class="{'green-text': v.ClosePricediv < 0}">{{ v.ClosePrice.toFixed(2) }}</div>
          <div class="percent" :class="{'green-text': v.ClosePricediv < 0}">{{ v.ClosePricedivstr }}</div>
        </div>
      </div>
    </template>
    <template v-else-if="loaded">
      <div style="width: 100%;">
        <img style="width:100%;height:auto" src="@/assets/no_data.png">
      </div>
    </template>
  </div>
</template>
<script>
import rzrq from '@/api/rzrq'
import {request} from '@/api/request'
import Utils from '@/utils/formatUnit'
export default {
  props: {
    tab: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      z: [],
      d: [],
      loaded: false
    }
  },
  watch: {
    tab() {
      this.resetData()
      this.getTopFive()
    },
    date(){
      this.resetData()
      this.getTopFive()
    }
  },
  async created() {
    await this.getTopFive()
  },
  methods: {
    formatUnit(val) {
      if(!val) return '--'
      return Utils.formatUnit(val)
    },
    resetData() {
      this.z = []
      this.d = []
      this.loaded = false
    },
    async getTopFive() {
      if (!this.date) return
      const res = await request.get({
          url: rzrq.queryFinaSecuAllTopFiveTable,
          params: {market: this.tab, date: this.date}
      })
      this.loaded = true
      if(res && res.length) {
        this.z = res.slice(0, 5)
        this.d = res.slice(5, 10)
      }
      return res
    }
  },
}
</script>
<style lang="stylus" scoped>
.topfive
  padding .08rem .12rem .12rem .14rem
.head
  display flex
  color #999999
  font-size .13rem
  margin-bottom .04rem
.xv
  width .3rem
  text-align left
.stock-name
  width .72rem
  text-align left
.buy
  width .86rem
  text-align right
.spj
  width .81rem
  text-align right
.percent
  width .8rem
  text-align right
.sep
  width 100%
  height .01rem
  background #F0F0F0
  margin .08rem 0
.item
  display flex
  line-height .2rem
  align-items center
  &:not(:last-child)
    margin-bottom .06rem
  .stock-name
    color #333333
    font-family PingFangSC-Regular,PingFang SC
    font-size  .14rem
  .buy,.spj,.percent
    color #D4332F
    font-family PingFangSC-Medium,PingFang SC
    font-weight 500
    font-size  .14rem
  .index
    background #D4332F
    text-align center
    width .14rem
    height .14rem
    border-radius .02rem
    color #FFFFFF
    line-height .14rem
    font-family PingFangSC-Regular,PingFang SC
  .green-bg
    background #258D01
  .green-text
    color #258D01
</style>